import React, { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { List } from '@ucheba/ui/components/List/desktop'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { authSelectors } from '@ucheba/store/auth'
import { useRouter } from 'next/router'
import { EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import { newsSelectors } from '@ucheba/store/institutions/news'
import { removeQueryParameters } from '@ucheba/utils/helpers/router'
import { useUserActivity } from '../../../../../../../utils/hooks/useUserActivity'
import NewsItem from '../../../../components/NewItem/desktop'
import { EActivityInfoPart } from '../../../../../../components/InstitutionExams/types'

const News: FC = () => {
  const { items, total } = useSelector(newsSelectors.entity)
  const isAuth = useSelector(authSelectors.isAuth)
  const { query, asPath } = useRouter()
  const { id: instId } = query
  const url = useMemo(() => {
    return removeQueryParameters(asPath)
  }, [asPath])

  const { setUserActivity } = useUserActivity()

  const handleShowAllClick = async (): Promise<void> => {
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId: Array.isArray(instId) ? Number(instId[0]) : Number(instId),
      data: { infoPart: EActivityInfoPart.news },
    })
  }

  if (!items?.length) return null

  return (
    <>
      <Heading h2='Новости' spacing='large' />

      <LimitedList
        onShowAll={() => {
          handleShowAllClick()
        }}
        isAuth={isAuth}
        id='news'
        limit={3}
        items={items}
        buttonText='Показать все новости'
        redirect={`${url}/news#news`}
        showButton={total > 3}
        showAllButtonLinkIsLink={false}
      >
        {({ limitedItems }) => (
          <List spacing='null'>
            {limitedItems.map(({ id, dateCreated, title, institutionId }) => (
              <NewsItem
                key={id}
                title={title}
                dateCreated={dateCreated}
                path={`/uz/${institutionId}/news/${id}#news`}
              />
            ))}
          </List>
        )}
      </LimitedList>

      <Spacing spacing='uxlarge' />
    </>
  )
}

export default News
